import {DirectiveOptions} from "vue";
import moment from "moment";
import AppConfig from "@/config/AppConfig";
import i18n from "@/locales/index";

const directive: DirectiveOptions = {

    inserted(el, node) {
        let sqlDateTime: Date = new Date(node.value);

        el.innerText = moment(sqlDateTime).fromNow();

    },

    update(el, node) {

        let sqlDateTime: Date = new Date(node.value);

        el.innerText = moment(sqlDateTime).fromNow();

    },

    componentUpdated(el, node) {

        let sqlDateTime: Date = new Date(node.value);

        el.innerText = moment(sqlDateTime).fromNow();

    }

}

export default directive;